/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconGdrive = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.92 1.37A.25.25 0 0 0 14.7 1h-6a.5.5 0 0 0-.5.46 1.543 1.543 0 0 0-.22.3l-7.44 13a1.501 1.501 0 0 0 0 1.42l3 6 .07.12a.25.25 0 0 0 .43 0L14.92 1.37zM5.47 22.63a.25.25 0 0 0 .23.37h13.42a1.502 1.502 0 0 0 1.3-.76l3.21-5.62a.25.25 0 0 0-.22-.37H9.12a.498.498 0 0 0-.44.27l-3.21 6.11zm17.95-7.88a.25.25 0 0 0 .22-.37l-7-12.23a.25.25 0 0 0-.44 0l-3 5.8a.498.498 0 0 0 0 .46l3.18 6.07a.498.498 0 0 0 .44.27h6.6z"
      />
    </svg>
  ),
);
